import { Box, Button, CircularProgress, Typography, withStyles } from "@material-ui/core";
import React, { useEffect, useState }from "react";
import Styles from "../commonStyles";
import AuthContainer from "../_components/AuthContainer";
import CommonPopup from "../_components/CommonPopup";
import InputPaper from "../_components/InputPaper";
import strings from "../_constants/strings";
import actions from "../_fpactions/fpswdactions";
import { goToLogin } from "../_helpers/navHelpers";
import ResendButton from "./ResendButton";

function OtpForm(props) {
  const { classes, state, setState, stage2, Stageresend } = props;
  const {
    TITLES: { OTP },
    LABELS: { USER_ID, SUBMIT }
  } = strings;
  const { submitting, otp, otpToken, error: { msg } } = state;
  const [openPopUp, setOpenPopup] = useState(false)

  useEffect(()=>{
    if(state.error.msg==="OTP has been expired."){
      setOpenPopup(true)
    }
  },[state, openPopUp]);
  const handleotpsubmit = e => {
    e && e.preventDefault();
    if (state.otp && state.otp.length === 6) {
      stage2();
    }
    setState({ type: actions.OTP_SUBMIT, stage2: stage2 });
  };

  const handlepopup =()=>{
    window.open("/","_self")
  }

  const handleonchange = e => {
    setState({ type: actions.ENTER_OTP, data: e.target.value });
  };

  const reSendOTP = () => {
    setState({
      type: actions.RESEND_OTP,
      otpToken: state.otpToken,
      // Stageresend: Stageresend
    });
    Stageresend && Stageresend();
  };

  const onExceed = () => {
    alert("Resend attempts exceeded, kindly start over...");
    goToLogin(props.history);
    // setState({ type: actions.FORGOT_PASS_RESET });
  };

  return (
    <AuthContainer formtype="enter otp">
      <Box className={classes.formBox}>
        <Typography gutterBottom className={classes.formtitle}>
          {OTP}
        </Typography>

        <InputPaper
          inputtype="text"
          placeholder={USER_ID}
          disabled={true}
          value={state.username}
        />

        <InputPaper
          autoFocus
          inputtype="text"
          placeholder="Enter OTP"
          value={state.otp}
          error={state.error.otp ? true : false}
          handler={handleonchange}
          errorPos='top'
          errorMsg={!!state.error.otp ? state.error.otp : null}
          disabled={submitting}
        />

        <Typography
          className={classes.errormsg}
          variant="caption"
          display="block"
          gutterBottom
        >
          {state.error.msg}
        </Typography>

        <Button
          variant="contained"
          type="submit"
          className={classes.loginbutton}
          onClick={handleotpsubmit}
          disabled={submitting}
        >
          {SUBMIT}
          {submitting ? <CircularProgress size="15" className={classes.spinner} /> : ""}
        </Button>
        <ResendButton
          timeOut={60}
          resendLimit={3}
          onClick={reSendOTP}
          onExceed={onExceed}
        />
        <CommonPopup
          openState={openPopUp}
          popupText={state.error.msg}
          handleClick={handlepopup}
        ></CommonPopup>
      </Box>
    </AuthContainer>
  );
}

export default withStyles(Styles)(OtpForm);
